import React from "react";
import { sweetalert } from "../../App";
import { BatchManagementModal } from "../modals/BatchManagementModal";
import Overlay from "../Overlay";
import FilterCard, { FIELD_TYPE, ReactSelect } from "../FilterCard";
import SimpleTable from "../tables/SimpleTable";
import {hideModal, parseDate, getPageOptions, slicePages, getNumPages, showModalNoOutsideClick, getNameFromID} from "../../util/FormatUtil";
import Select from "react-select";
import Batch from "../../types/Batch";
import { BatchSelect } from "./selects/BatchSelect";
import TestsAPI from "../../network/TestsAPI";
import BatchesAPI from "../../network/BatchesAPI";
import NetworkUtil from "../../network/NetworkUtil";
import SystemAPI from "../../network/SystemAPI";
import {AdminPages} from "./AdminNav";
import PaginationTool from "../PaginationTool";
import ServicesAPI from "../../network/ServicesAPI";
import { Column } from "../tables/TableBase";
import { Sorter, TableOrder } from "../../sorting/Sorter";

interface BatchManagementState {
  showLoading: boolean;
  selectedBatch: Batch;
  batchQueryResults: Batch[];
  tableData: {
    BatchNum: string;
    Service;
    ResultApprovedDate: Date;
    Notes: string;
    ExportUploadedBy: string;
    MachineData: any;
  }[];
  filter?: {
    Service;
    ResultApprovedDate: Date;
  };
  direction?:TableOrder
  page_options: ReactSelect[];
  selected_page?;
  serviceTypeOptions: { label: string; value: number }[];
  filteredBatch: { label; value: Batch }[];
  pageCustomQuestions?
}

export class BatchManagement extends React.Component<
  any,
  BatchManagementState
> {
  constructor(props) {

    super(props);
    this.state = {
      showLoading: true,
      selectedBatch: null,
      batchQueryResults: [] as any,
      tableData: [] as any,
      filter: {
        Service: "",
        ResultApprovedDate: null,
      },
      filteredBatch: [],
      direction: "asc",
      page_options: [{ label: "1", value: "1" }],
      selected_page: { label: 1, value: 1 },
      serviceTypeOptions: [{ label: "", value: -1 }],
      pageCustomQuestions: []
    };

    this.queryBatchData = this.queryBatchData.bind(this);
    this.createOrModifyBatch = this.createOrModifyBatch.bind(this);
    this.handleExportToCSV = this.handleExportToCSV.bind(this);
    this.renderBatchFilterFields = this.renderBatchFilterFields.bind(this);
    this.changePage = this.changePage.bind(this);
  }

  componentDidMount() {
    this.setState({ showLoading: true }, async () => {
      SystemAPI.getCustomQuestions(AdminPages.BatchManagement).then(res =>{
        this.setState({pageCustomQuestions:res.questions})
    })

      let services = await ServicesAPI.getAllServicesForMachineExport();
        if (!services.success) {
            return sweetalert.fire({
                title: 'Error',
                text: services.reason,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }

        let temp = services.data.filter(s => s.ExportParseURL && s.IsEnabled) as any
        temp = temp.map((s) => {
          return { label: s.Name, value: s.ID };
        })

        this.setState({serviceTypeOptions: temp, showLoading: false})
    });
  }

  queryBatchData(page: number) {
    this.setState({ showLoading: true }, async () => {
      let results = await BatchesAPI.getFilteredBatches({
        filter: {
          BatchNum: this.state.filteredBatch
            ? this.state.filteredBatch.map((b) => b.value.ID)
            : null,
          Service: this.state.filter.Service,
          ResultApprovedDate: this.state.filter.ResultApprovedDate,
        },
      });
      this.setState({ showLoading: false });
      if (!results.success) {
        this.setState({ showLoading: false, tableData: null, batchQueryResults: null });
        sweetalert.fire({
          title: "",
          text: "Unable to filter Batches data at this time",
          icon: "error",
        });
        return;
      }
      else if(results.response.length < 1){
        this.setState({ showLoading: false, tableData:null, batchQueryResults: null });
        sweetalert.fire({
          title: "",
          text: "No Batches found",
          icon: "error",
        });
        return;
      }

      let itemsPerPage = 25;
      let numberOfPages = getNumPages(results.response, itemsPerPage);
      this.setState({
        showLoading: false,
        tableData: slicePages(results.response, page, itemsPerPage),
        batchQueryResults: results.response,
        page_options: getPageOptions(numberOfPages),
      });
    });
  }

  createOrModifyBatch(batch) {
    this.setState({ showLoading: true }, async () => {
      let response = await (!batch.ID
        ? BatchesAPI.createBatch(batch)
        : BatchesAPI.editBatch(batch));
      if (!response.success) {
        sweetalert.fire({ title: "", text: response.reason, icon: "error" });
        this.setState({showLoading: false})
      } else {
        this.setState({ selectedBatch: null });
        sweetalert
          .fire({ title: "", text: "Batch saved", icon: "success" })
          .then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
      }
    });
  }

  handleExportToCSV() {
    this.setState({ showLoading: true }, async () => {
      await NetworkUtil.downloadCSV(
        "/api/admin/lab/batch/csvExport",
        "BatchManagementData.xlsx",
        { batchData: this.state.batchQueryResults }
      );
      this.setState({ showLoading: false });
    });
  }

  renderBatchFilterFields() {
    return (
      <React.Fragment>
        <BatchSelect
          finishedLoading={() => this.setState({ showLoading: false })}
          multi={true}
          onSelected={(batch: { label; value: Batch }[]) =>
            this.setState({ filteredBatch: batch })
          }
          value={this.state.filteredBatch ? 1 : null}
        />
        <FilterCard
          fields={[
            {
              label: "Service",
              key: "Service",
              type: FIELD_TYPE.SELECT,
              options: this.state.serviceTypeOptions,
              isMapped: true,
              isMulti: true,
              textType: "text",
            },
            {
              label: "Result Approved Date",
              key: "ResultApprovedDate",
              type: FIELD_TYPE.DATE,
            },
          ]}
          filterChanged={(e) => this.setState({ filter: e })}
        />
      </React.Fragment>
    );
  }

  useSorter(col:Column){
    let sorter = new Sorter<any>()
  
    this.setState({tableData: sorter.sortByKey(this.state.tableData, col.key as keyof any, this.state.direction), direction: this.state.direction === 'asc' ? 'desc' : 'asc'});
  }



  changePage(page: number) {
    let allBatches = this.state.batchQueryResults;
    let returnData = slicePages(allBatches, page, 25);
    this.setState({ tableData: returnData });
  }

  render() {

    // console.log('Batch Mgmt State', this.state)
    return (
      <React.Fragment>
        <PaginationTool />
        <Overlay show_loading={this.state.showLoading} />
        <BatchManagementModal
          selectedBatch={
            this.state.selectedBatch ? this.state.selectedBatch : ({} as Batch)
          }
          onSubmit={(batch) => {
            hideModal(BatchManagementModal.ID);
            this.createOrModifyBatch(batch);
          }}
          pageCustomQuestions={this.state.pageCustomQuestions}
        />
        <div className="container-fluid">
          <div className={"row"}>
            <div className="col-12 col-md-12 col-lg-8 col-xl-5 pt-2">
              <div className="card mb-2">
                <div className="card-header verlag-bold">
                  <h4>Batch Management</h4>
                </div>
                <div className="card-body">
                  {this.renderBatchFilterFields()}
                </div>
                <div className="card-footer">
                  <button
                    className={"btn immySubmitButtonOutline"}
                    onClick={() =>
                      this.setState(
                        { selected_page: { label: 1, value: 1 } },
                        () =>
                          this.queryBatchData(this.state.selected_page.value)
                      )
                    }
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-outline-success float-right"
                    onClick={() =>
                      this.setState({ selectedBatch: {} as Batch }, () =>
                        showModalNoOutsideClick(BatchManagementModal.ID)
                      )
                    }
                  >
                    Create New
                  </button>
                </div>
              </div>
            </div>

          
            {this.state.batchQueryResults &&
              this.state.batchQueryResults.length > 0 && (
                <div className="col-md-12 pt-2">
                  <div className="card mt-2" style={{marginBottom: '4rem'}}>
                    <div className="card-header verlag-bold stickToTop">
                      <h4 className="text-center text-md-left">
                        Batch Data
                        <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                          <h4 className={"float-md-right"}>
                            Total: {this.state.batchQueryResults.length}
                          </h4>
                          <h4 className="float-right align-middle pr-2 ml-5">
                            Page{" "}
                          </h4>
                          <div className=" align-middle float-right pages ">
                            <Select
                              isSearchable={true}
                              placeholder={"1"}
                              noOptionsMessage={() => "No option"}
                              value={this.state.selected_page}
                              onChange={(e: ReactSelect) =>
                                this.setState({ selected_page: e }, () =>
                                  this.changePage(e.value)
                                )
                              }
                              className={"state_select"}
                              options={this.state.page_options}
                            />
                          </div>
                        </section>
                        <button
                          className={"d-none d-md-inline btn btn-outline-primary ml-3"}
                          onClick={() => this.handleExportToCSV()}
                        >
                          Export to CSV
                        </button>
                      </h4>
                    </div>
                    <div className="card-body p-0 m-0 table-responsive">
                      <SimpleTable
                        columns={[
                          {
                            label: "Batch Number",
                            key: "BatchNum",
                            rawFormat: (val) => {
                              return (
                                <a
                                  href={"#!"}
                                  className={'tableNameLinkColor'}
                                  onClick={() => {
                                    this.setState({ selectedBatch: val }, () =>
                                      showModalNoOutsideClick(BatchManagementModal.ID)
                                    );
                                  }}
                                >
                                  {val.BatchNum}
                                </a>
                              );
                            },
                            popoverText: "Click to sort by Batch Number",
                          },
                          {
                            label: "Service",
                            key: "ServiceID",
                            rawFormat: (val) => {
                              return (getNameFromID(val.ServiceID, this.state.serviceTypeOptions)) 
                            },
                            popoverText: "Click to sort by Service",
                          },
                          {
                            label: "Result Approved Date",
                            key: "ResultApprovedDate",
                            rawFormat: (val) => {
                              return parseDate(val.ResultApprovedDate);
                            },
                            popoverText:
                              "Click to sort by Result Approved Date",
                          },
                          {
                            label: "Export Uploaded By",
                            key: "ExportUploadedBy",
                            popoverText: "Click to sort by Result Approved By",
                          },
                          {
                            label: "Notes",
                            key: "Notes",
                            popoverText: "Click to sort by Notes",
                          },
                        ]}
                        table_data={this.state.tableData}
                        columnClickedCallback={(col =>{
                          this.useSorter(col);
                      })}
                      />
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
